<script lang="ts">
</script>

<div class="svg-icon svg-baseline"><slot /></div>

<style lang="scss">
  .svg-icon {
    display: inline-flex;
    align-self: center;
  }

  :global(.svg-icon svg) {
    height: 1.75rem;
    width: 1.75rem;
  }

  :global(.svg-icon.svg-baseline svg) {
    position: relative;
  }

  :global(.svelte-button .svg-icon svg) {
    top: 0.425rem;
    left: 0.5rem;
  }
</style>
